var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n\n\n"+_vm._s(_vm.name)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }